function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useEffect } from "react";
import { useMapElement } from "@macrostrat/mapbox-react";
import { useAPIResult } from "@macrostrat/ui-components";
import { SETTINGS } from "~/map-interface/settings";
var sourceMapStyle = {
  version: 8,
  sources: {
    "burwell-sources": {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features: []
      }
    }
  },
  layers: [{
    id: "sources-fill",
    type: "fill",
    source: "burwell-sources",
    // reference the data source
    paint: {
      "fill-opacity": ["get", "opacity"],
      "fill-color": ["case", ["boolean", ["feature-state", "active"], false], "#ffae80", "#aaaaaa"]
    }
  }, {
    id: "outline",
    type: "line",
    source: "burwell-sources",
    layout: {},
    paint: {
      "line-color": ["case", ["boolean", ["feature-state", "clicked"], false], "#ffae80", "#333"],
      "line-width": 1.5
    }
  }]
};

function mergeStyles(map, style) {
  for (var _i = 0, _Object$entries = Object.entries(style.sources); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    if (!map.getSource(key)) {
      map.addSource(key, value);
    }
  }

  var _iterator = _createForOfIteratorHelper(style.layers),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var layer = _step.value;

      if (!map.getLayer(layer.id)) {
        map.addLayer(layer);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

function removeStyle(map, style) {
  for (var key in style.sources) {
    if (map.getSource(key)) {
      map.removeSource(key);
    }
  }

  var _iterator2 = _createForOfIteratorHelper(style.layers),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var layer = _step2.value;

      if (map.getLayer(layer.id)) {
        map.removeLayer(layer.id);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}

export function MapSourcesLayer() {
  var map = useMapElement();
  var featureData = useAPIResult(SETTINGS.apiDomain + "/api/v2/defs/sources", {
    all: true,
    format: "geojson_bare"
  });
  useEffect(function () {
    if (!map || !featureData) return;

    var styles = _objectSpread({}, sourceMapStyle);

    featureData.features.forEach(function (f) {
      var lvl = Math.max(["small", "medium", "large"].indexOf(f.properties.scale), 0);
      f.properties.opacity = (lvl + 0.5) / 4;
    });
    styles.sources["burwell-sources"].data = featureData;

    if (map.isStyleLoaded()) {
      mergeStyles(map, styles);
    } else {
      map.on("style.load", function () {
        console.log("Merging styles");
        mergeStyles(map, styles);
      });
    }

    return function () {
      removeStyle(map, styles);
    };
  }, [map, featureData]);
  return null;
}